<template>
  <div v-if="!$auth.loading">
    <div class="home">
      <Attendance/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Attendance from '@/components/Attendance.vue'

export default {
  name: 'home',
  components: {
    Attendance
  }
}
</script>
